import {
  React
} from 'react';

import {
  HFillContainerVH,
  Spinner
} from '@vodacom/web-common';

import {
  GeneralError,
  SearchPageError,
  TechnicalError,
  TextOnlyError
} from 'components';

import {
  CustomColors,
  ErrorKeys
} from '../constants';

import {
  NoOffers
} from 'journeys';

export const HandleRender = ({ children, error, isError, isLoading, loader }) => {

  const selectError = () => {

    switch (error?.type) {

      case ErrorKeys.Children:
        return children;

      case ErrorKeys.General:
        return <GeneralError value={error.title}/>;

      case ErrorKeys.Offers:
        return <NoOffers/>;

      case ErrorKeys.Search:
        return <SearchPageError title={error.title} />;

      case ErrorKeys.TextOnly:
        return (

          <TextOnlyError
            title={error.title}
            pageName={error.pageName}
            tagViewData={{
              ...error.tagViewData,
              page_event: 'page_error',
              error_message: error.title
            }} />
        );

      case ErrorKeys.Empty:
        return <></>;

      default:
        return <TechnicalError message={error?.title} bottomButtonClick={error?.onClick}/>;
    }
  };

  const buildLoader = () => {

    return (

      <HFillContainerVH
        margin={loader?.margin || '0 auto'}
        height={loader?.height}>

        <Spinner
          color={CustomColors.Red1}
          size={ loader?.size || '200'} />
      </HFillContainerVH>
    );
  };

  return (
    <>
      {
        isError
          ? selectError()
          : isLoading
            ? buildLoader()
            : children
      }
    </>
  );
};